import { render } from "./card.vue?vue&type=template&id=33a784d1&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=33a784d1&scoped=true&lang=scss"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a784d1"]])

export default __exports__